import { LucideIcon } from 'lucide-react';

interface LearningBlockProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ElementType;
  titleClassName?: string;
  useH1?: boolean;
}

export const LearningBlock: React.FC<LearningBlockProps> = ({ 
  title, 
  children, 
  icon: Icon,
  titleClassName = "text-xl font-semibold",
  useH1 = false
}) => {
  return (
    <div className="space-y-4 w-full overflow-hidden">
      <div className="flex items-center justify-center text-center gap-3">
        {Icon && (
          <div className="bg-orange-100 p-2 rounded-lg">
            <Icon className="w-5 h-5 text-orange-600" />
          </div>
        )}
        {useH1 ? (
          <h1 className={titleClassName}>{title}</h1>
        ) : (
          <h2 className={titleClassName}>{title}</h2>
        )}
      </div>
      <div className="ml-0 w-full overflow-hidden">
        {children}
      </div>
    </div>
  );
};